import { chartBody } from "./chartBody.model";
import { chartHeader } from "./chartHeader";

export class LaunchKeyDates {

    data:chartBody[];
    header:chartHeader[];

    constructor() {
        this.data = [];
        this.header = [];
    }

}